import API from 'api/clients'
import { queryService } from 'modules/module-api'
import { all, fork } from 'redux-saga/effects'

import ParcelsSaga from './ParcelsSaga'

export default function* deliveriesSagas() {
  yield all([fork(new ParcelsSaga(API, queryService).supervise)])
}
